const NotFoundParagraph = () => {
    return (
      <p className="text-gray-400 h-[70vh] flex items-center justify-center">No results found.</p>
    );
  };
  
export default NotFoundParagraph;  